export const ASSIGNEE_NAME_AVATAR_TESTID = 'assignee-name-avatar';
export const ASSIGNEE_EMAIL_AVATAR_TESTID = 'assignee-email-avatar';
